<template>
  <div class="content">
    <!-- <div class="flex h-44"> -->
    <el-tabs v-model="currentRoundId" type="card" @tab-click="handleTabClick" addable
      @tab-add="$refs.dialog.showDialog('addRound')">
      <el-tab-pane :label="i.name" :name="i.id + ''" v-for="(i, index) in roundList" :key="index"></el-tab-pane>
    </el-tabs>
    <!-- </div> -->
    <div class="flex h-44 search-action-bar">
      <TaskForm @formValue="filterFormValue" @closeDialog="resetSelectedTasks" />
      <div style="display: flex;" class="action-bar">
        <!-- 暂时隐藏下个版本使用 -->
        <!-- <UploadFile /> -->
        <TaskDialog @success="refreshTasks" @closeDialog="resetSelectedTasks" :selectedTasks="selectedTasks"
          :currentRound="currentRound" ref="dialog" />

        <TaskActions ref="actions" :currentRound="currentRound" :selectedTasks="selectedTasks" @closeDialog="resetSelectedTasks"
          @success="refreshTasks" />
      </div>
    </div>
    <div class="main">
      <el-table ref="table" height="calc(100% - 36px)" style="width: 100%" :data="taskObjectList" border
        @selection-change="handleSelectionChange" @sort-change="handleSortChange">
        <el-table-column type="selection" width="55" align="center">
        </el-table-column>
        <el-table-column type="index" label="#" width="50" align="center"></el-table-column>
        <el-table-column prop="subject.code" label="编号" width="120" align="center"
          show-overflow-tooltip></el-table-column>
        <el-table-column prop="name" label="测评对象" show-overflow-tooltip></el-table-column>

        <el-table-column prop="evaluation_form.name" label="测评规则" show-overflow-tooltip></el-table-column>
        <el-table-column prop="surveyor.name" label="调查员" width="100" align="center"
          show-overflow-tooltip></el-table-column>

        <el-table-column prop="comment" label="描述" show-overflow-tooltip></el-table-column>
        <el-table-column prop="tags" label="标签" header-align="center">
          <template slot-scope="scope">
            <el-tag size="mini" v-for="tag in scope.row.subject.tags" :key="tag.id" :type="tag.type"
              style="margin-right: 5px">{{ tag.name }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="note" label="备注" show-overflow-tooltip></el-table-column>
        <el-table-column label="得分" prop="score" align="center" width="100" sortable="custom">
          <template #default="{ row }">
            <span v-if="row.score != null">{{ row.score.toFixed(1) }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center" width="100">
          <template #default="{ row }">
            <TaskStatus :status="row.status" />
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" max-width="160" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.created_at | dateTimeBeautify }}
          </template>
        </el-table-column>

        <el-table-column prop="actions" width="180" label="操作" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-dropdown style="margin-right: 10px" @command="showMultiActionDialog(scope.row, $event)">
              <el-button type="text" size="small">操作</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="confirm">审核通过</el-dropdown-item>
                <el-dropdown-item command="reject">打回重测</el-dropdown-item>
                <el-dropdown-item command="complete">任务完结</el-dropdown-item>
                <el-dropdown-item command="appealing">开启申诉</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button style="margin-right: 0px; color: #606266" type="text" size="small" slot="reference"
              @click="routeToDetail(scope.row)">查看</el-button>
            <el-button style="margin-right: 10px" type="text" size="small" slot="reference"
              @click="handleEditTask(scope.row)">编辑</el-button>
            <el-popconfirm title="谨慎删除，删除后无法恢复" @confirm="handleDeleteTask(scope.row)"
              @onConfirm="handleDeleteTask(scope.row)" v-role="['owner', 'admin']">
              <el-button type="text" style="color: #f56c6c" size="small" slot="reference">删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <div class="flex m-auto" v-if="pagination.total">
        <el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"
          :page-size="pagination.size" :page-sizes="[15, 30, 50, 100, 200]" :current-page.sync="pagination.page"
          @current-change="handleCurrentPageChange" @size-change="handlePageSizeChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import TaskDialog from "./task-dialog.vue";
import TaskForm from "./task-form.vue";
import TaskStatus from "./task-status.vue";
import TaskActions from "./task-actions.vue";
// import UploadFile from "@/page/components/uploadFile-evaluation.vue";
import { taskRounds, taskEvent, deleteTaskEvent } from "@/api/project";

export default {
  name: "TaskList",
  props: {
    clickGroupData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      pagination: {
        page: 1,
        size: 15,
        total: 0,
      },
      searchFormValue: {},
      roundList: [],
      taskObjectList: [],
      currentRoundId: "",
      selectedTasks: [],
      checkList: [],
      currentRound: null,
      orderBy: "",
    };
  },
  components: {
    TaskDialog,
    TaskForm,
    TaskStatus,
    TaskActions,
    // UploadFile,
  },
  activated() {
    // this.setCheckList();
  },
  mounted() {
    this.queryRounds();
  },
  methods: {
    // 显示批量操作弹窗
    showMultiActionDialog(row, status) {
      if (this.selectedTasks.length) {
        this.resetSelectedTasks();
      }
      this.selectedTasks.push(row);
      this.$refs.actions.showDialog("taskActions", row, status);
    },

    filterFormValue(data) {
      this.searchFormValue = data;
      this.pagination.page = 1;
      this.queryTasks();
    },

    // 查看某一个 Task
    routeToDetail(data) {
      if (!data.evaluation_form_id) {
        this.$message.warning("该测评对象未配置测评规则，请先进行配置");
        return;
      }
      this.$router.push({
        name: "EvaluationTaskEvents",
        params: {
          taskId: data.id,
        },
      });
    },

    // 编辑某一个 Task
    handleEditTask(data) {
      if (this.selectedTasks.length) {
        this.resetSelectedTasks();
      }
      this.selectedTasks.push(data);
      this.$refs.dialog.showDialog("edit");
    },

    resetSelectedTasks() {
      this.$refs.table.clearSelection();
      this.selectedTasks = [];
    },

    // 刷新 Task 列表
    refreshTasks() {
      this.$refs.table.clearSelection();
      this.queryRounds();
      this.queryTasks();
    },

    // 响应选择变化
    handleSelectionChange(data) {
      this.selectedTasks = data;
    },

    // 响应排序变化
    handleSortChange({ prop, order }) {
      this.orderBy = prop + ":" + (order === "ascending" ? "asc" : "desc");
      this.queryTasks();
    },

    // 响应页码变化
    handlePageSizeChange(size) {
      this.pagination.size = size;
      this.queryTasks();
    },

    // 响应页数变化
    handleCurrentPageChange(data) {
      this.pagination.page = data;
      this.queryTasks();
    },

    // todo 该函数似乎没有用
    showDialog() {
      this.$refs.dialog.handleShow();
    },

    // 删除 Task
    handleDeleteTask(row) {
      let id = row.id;
      deleteTaskEvent(id).then(() => {
        this.$message({
          type: "success",
          message: "删除成功",
        });
        this.queryTasks();
      });
    },

    // 刷新列表
    setCheckList() {
      this.queryRounds();
    },

    handleTabClick(tab) {
      const id = tab.name;
      this.currentRound = this.roundList.find(
        (item) => item.id.toString() === id
      );
      this.queryTasks();
    },

    // 查询轮次列表
    queryRounds() {
      let project_id = this.$route.params.id;
      taskRounds({ project_id }).then((res) => {
        this.roundList = res.data;
        if (res.data.length) {
          if (this.currentRoundId == 0) {
            this.currentRoundId = res.data[0].id + "";
            this.currentRound = res.data[0];
          }
        }
        this.queryTasks();
      });
    },

    // 查询 Task 列表
    queryTasks() {
      let project_id = this.$route.params.id;
      let params = {};
      // console.log(this.searchFormValue);
      for (const key in this.searchFormValue) {
        const item = this.searchFormValue[key];
        if (item && item.length) {
          params[key] = item;
        }
        if (typeof item === "number") {
          params[key] = item;
        }
      }

      // 如果需要排序
      if (this.orderBy) {
        params.order_by = this.orderBy;
      }

      taskEvent({
        page: this.pagination.page,
        size: this.pagination.size,
        project_id,
        round_id: this.currentRoundId,
        group_ids: this.clickGroupData,
        ...params,
      }).then((res) => {
        this.taskObjectList = res.data;
        this.pagination.total = res.meta.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.flex {
  display: flex;
  align-items: center;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: flex-start;
}

.flex.m-auto {
  justify-content: center;
  padding-top: 10px;
}

.h-44 {
  min-height: 44px;
  margin-bottom: 10px;
}

.content {
  height: 100%;
}

.main {
  background: #fff;
  height: calc(100% - 44px - 10px - 44px);
}
</style>
